import { useState, useEffect } from 'react';
import {
  Page,
  Card,
  FormLayout,
  TextField,
  Select,
  Toast,
  BlockStack,
  Text
} from '@shopify/polaris';
import { settingsAPI } from '../utils/api';

function Settings() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);
  const [settings, setSettings] = useState({
    exportFileNamingPattern: '{vendorCode}_{date}_{time}'
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await settingsAPI.get();
        setSettings(response.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
        setToast({ content: 'Error loading settings', error: true });
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);
      await settingsAPI.update(settings);
      setToast({ content: 'Settings saved successfully' });
    } catch (error) {
      setToast({ content: 'Error saving settings', error: true });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Page
      title="Settings"
      primaryAction={{
        content: 'Save',
        onAction: handleSave,
        loading: saving
      }}
    >
      <BlockStack gap="400">
        <Card>
              <BlockStack gap="400">
                <Text variant="headingMd">Export Settings</Text>
                
                <FormLayout>
                  <TextField
                    label="Export File Naming Pattern"
                    value={settings.exportFileNamingPattern}
                    onChange={(value) => setSettings({ ...settings, exportFileNamingPattern: value })}
                    helpText="Available variables: {vendorCode}, {vendorName}, {date}, {time}"
                    autoComplete="off"
                  />
                </FormLayout>
                
                <Text tone="subdued" variant="bodySm">
                  Timezone is automatically detected from your Shopify store settings.
                </Text>
              </BlockStack>
        </Card>

        <Card>
              <BlockStack gap="400">
                <Text variant="headingMd">About</Text>
                <Text tone="subdued">
                  Vendor Orders Management App v1.0.0
                </Text>
                <Text tone="subdued">
                  This app helps you manage dropship vendor fulfillment workflows by organizing orders by vendor and exporting them in custom formats.
                </Text>
              </BlockStack>
        </Card>

        {toast && (
          <Toast
            content={toast.content}
            error={toast.error}
            onDismiss={() => setToast(null)}
          />
        )}
      </BlockStack>
    </Page>
  );
}

export default Settings;
